import { defineSlotRecipe } from '@chakra-ui/react';
import { tabsAnatomy } from '@chakra-ui/react/anatomy';

export const tabsSlotRecipe = defineSlotRecipe({
  className: 'chakra-menu',
  slots: tabsAnatomy.keys(),
  base: {
    trigger: {
      base: {
        borderRadius: '16px'
      }
    },
    content: {
      _horizontal: {
        width: '100%',
        pt: '4px'
      }
    }
  }
});
